import React from 'react';
import { withRouter } from 'react-router-dom';
import { GetFormat, convertToPhilippinesTime } from '../../../AppUtil/AppUtil';
import AccountService from '../../../Service/AccountService';
import Table from '../../Common/Table';
import NoAccess from '../../NoAccess/index';
import Filter from './Filter';
import qs from 'query-string';
import { hot } from 'react-hot-loader';

const PRECISION_TWO = 2;
const SERVICE_FEE = 2.5;
class Transactions extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			// _customFilterQuery: `&channel=&type=all&status=PENDING,APPROVE,COMPLETED,DECLINE,FAILED,SUCCESS&state=PENDING,APPROVE,COMPLETED,DECLINE,FAILED,SUCCESS&fromDate=${moment()
			// 	.subtract(1, 'month')
			// 	.startOf('month')
			// 	.format('YYYY-MM-DD')}&toDate= ${moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')}&`,

			_customFilterQuery: '',
			_filterTab: 'Transaction List',
			type: ''
		};
	}

	removeSecondPageParameter(url) {
		// Splitting the URL by "&" to get individual parameters
		const parts = url.split('&');

		// Counting the occurrences of "page=" to determine which one to remove
		let count = 0;
		for (let i = 0; i < parts.length; i++) {
			if (parts[i].startsWith('page=')) {
				count++;
				if (count === 2) {
					// Removing the second occurrence of "page="
					parts.splice(i, 1);
					break;
				}
			}
		}

		// Reconstructing the URL
		const modifiedUrl = parts.join('&');
		return modifiedUrl;
	}

	dataSource = async queryUrl => {
		queryUrl = this.removeSecondPageParameter(queryUrl);

		return AccountService.getTransactions(queryUrl);
	};

	setType = m => {
		this.setState({ type: m });
	};

	getType = () => {
		const { type } = qs.parse(window.location.search);
		return { type };
	};

	setTranType = tranType => {
		const labelsMap = {
			EMI: 'Loan Payment',
			PRINCIPAL: 'Loan Funded',
			default: 'Service Fee'
		};
		return labelsMap[tranType] || labelsMap.default;
	};

	getTransactionAmount = (emi_amount, principal, type) => {
		if (type === 'PRINCIPAL') {
			return principal;
		}
		return emi_amount;
	};

	getTransactionFee = (_emi_amount, principal, type, tableData) => {
		if (type === 'PRINCIPAL') {
			return (principal * tableData.rowData[14]) / 100;
		}
		return tableData.rowData[15];
	};

	onResetFilter = () => {
		this.setState({
			_customFilterQuery: ''
		});
	};

	setTranStatus = (value, tranStatus) => {
		if (tranStatus === 'PAYMENTS_STOPED') {
			return 'PAUSED';
		} else if (tranStatus === 'PRE_MODIFIED' || tranStatus === 'POST_MODIFIED') {
			return 'MODIFIED';
		} else if (tranStatus === 'DECLINE') {
			return 'DECLINED';
		} else if (tranStatus === 'APPROVE') {
			return 'APPROVED';
		} else {
			return value?.toUpperCase() || 'N/A';
		}
	};

	onSearch = obj => {
		const queryParams = new URLSearchParams(window.location.search);

		// Convert URLSearchParams to object
		const queryParamsObject = {};
		for (const [key, value] of queryParams.entries()) {
			queryParamsObject[key] = value;
		}

		// Update status based on type
		if (queryParamsObject.status === 'ALL') {
			if (queryParamsObject.type === 'top-up' || queryParamsObject.type === 'cash-out') {
				queryParamsObject.status = 'PENDING,FAILED,SUCCESS';
			} else if (queryParamsObject.type === 'ALL') {
				queryParamsObject.status =
					'PENDING,DECLINE,APPROVE,PRE_MODIFIED,POST_MODIFIED,COMPLETED,PAYMENTS_STOPED,DELETED,FAILED,PAID,SUCCESS';
			} else if (queryParamsObject.type === 'outgoing fund') {
				queryParamsObject.status = 'PAID';
			} else {
				queryParamsObject.status =
					'PENDING,DECLINE,APPROVE,PRE_MODIFIED,POST_MODIFIED,PAYMENTS_STOPED,COMPLETED,DELETED,PAYMENTS_STOPED';
			}
		}

		// Build custom filter query
		let customFilterQuery = '';
		for (const key of Object.keys(queryParamsObject)) {
			if (queryParamsObject[key]) {
				if (queryParamsObject[key] === 'PAUSED') {
					queryParamsObject[key] = 'PAYMENTS_STOPED';
				} else if (queryParamsObject[key] === 'MODIFIED') {
					queryParamsObject[key] = 'PRE_MODIFIED,POST_MODIFIED';
				}

				customFilterQuery += `${key}=${queryParamsObject[key]}&`;
			}
		}

		this.setState({
			_customFilterQuery: customFilterQuery
		});
	};

	formatAmount = (amount, colName) => {
		if (colName === 'annual_rate') {
			return `${parseFloat(amount).toFixed(2)}%`;
		} else {
			const value = parseFloat(amount).toFixed(2);
			let num = value.toString().replace(/(\s)/g, '');
			num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

			return `${num}`;
		}
	};

	render() {
		const dayjs = require('dayjs');

		const amountColOpts = {
			sort: true,
			customBodyRender: (value, tableMeta) => {
				const colName = tableHeaders._viewCol[tableMeta.columnIndex].name;
				return <span className="bold-important">{this.formatAmount(value, colName)}</span>;
			}
		};
		if (!this.props.authorized && this.props.match.path === '/admin/transactions') {
			return <NoAccess />;
		}
		const tableHeaders = {
			_defaultCol: [
				{
					name: 'id',
					label: 'ID',
					options: {
						sort: false
					}
				},
				{
					name: 'transfer_date',
					label: 'Transfer Date',
					options: {
						sort: false,
						customBodyRender: value => {
							if (value !== undefined) {
								const transferDate = value;
								return <span className="bold-important">{convertToPhilippinesTime(transferDate)}</span>;
							}
						}
					}
				},

				{
					name: 'sender_first_name',
					label: 'From',
					options: {
						sort: false,
						customBodyRender: (_value, tableMeta) => {
							return ` ${tableMeta.rowData[6]}`;
						}
					}
				},
				{
					name: 'sender_last_name',
					options: {
						display: 'excluded'
					}
				},
				{
					name: 'receiver_first_name',
					label: 'To',
					options: {
						sort: false,
						customBodyRender: (_value, tableMeta) => {
							return ` ${tableMeta.rowData[4]}`;
						}
					}
				},
				{
					name: 'receiver_last_name',
					options: {
						display: 'excluded'
					}
				},

				{
					name: 'transfer_type',
					label: 'Type',
					options: {
						sort: false,
						customBodyRender: value => {
							return this.setTranType(value);
						}
					}
				},
				{
					name: 'loan_id',
					label: 'Loan',
					options: {
						sort: false,
						customBodyRender: value => {
							return (
								<a
									href={`/admin/loans/${value}`}
									className="bold-important"
									// eslint-disable-next-line react/jsx-no-target-blank
									target="_blank">
									{value}
								</a>
							);
						}
					}
				},
				{
					name: 'principal',
					options: {
						display: 'excluded'
					}
				},

				{
					name: 'emi_amount',
					label: 'Service Fee(₱)',
					options: {
						sort: false,
						customBodyRender: (value, tableMeta) => {
							const emiAmount = value;
							const principal = tableMeta.rowData[9];
							const loanType = tableMeta.rowData[7];

							const serviceFee = this.getTransactionFee(emiAmount, principal, loanType, tableMeta);
							return (
								<span className="bold-important">{parseFloat(serviceFee).toFixed(PRECISION_TWO)}</span>
							);
						}
					}
				},
				{
					name: 'sender_email',
					label: 'Sender Email',
					options: {
						sort: false
					}
				},
				{
					name: 'receiver_email',
					label: 'Receiver Email',
					options: {
						sort: false
					}
				},
				{
					name: 'principal_service_fee',
					options: {
						display: 'none',
						customBodyRender: value => {
							if (value !== undefined) {
								return <span className="bold-important">{value}</span>;
							}
						}
					}
				},
				{
					name: 'transaction_fee',
					options: {
						display: 'none',
						customBodyRender: value => {
							if (value !== undefined) {
								return <span className="bold-important">{value}</span>;
							}
						}
					}
				}
			],

			_viewCol: [
				{
					name: 'transfer_date',
					label: 'Date/Time',
					options: {
						sort: false,
						customBodyRender: value => {
							return (
								<span className="bold-important">
									{value ? convertToPhilippinesTime(value) : 'N/A'}
									{/* {value ? dayjs(value).format('DD-MMM-YYYY hh:mm A') : 'N/A'} */}
								</span>
							);
						}
					}
				},
				{
					name: 'loan_id',
					label: 'Loan ID',
					options: {
						// sort: true,
						sort: false,
						customBodyRender: (value, tableMeta) => {
							if (value)
								return <span className="bold-important">LA{String(value).padStart(5, '0')}</span>;
							return 'N/A';
						}
					}
				},

				{
					name: 'loan_type',
					label: 'Loan ID',
					options: {
						display: 'excluded'
					}
				},

				{
					name: 'transfer_type',
					label: 'Loan Type',
					options: {
						sort: false,
						customBodyRender: value => {
							return value;
						}
					}
				},

				{
					name: 'sender_first_name',
					label: 'From',
					options: {
						sort: false,
						customBodyRender: (_value, tableMeta) => {
							if (tableMeta.rowData[3] === 'LEND') {
								return tableMeta.rowData[7] || tableMeta.rowData[6];
							} else if (tableMeta.rowData[2] === 'LEND' && this.getType().type === 'incoming fund') {
								return tableMeta.rowData[6];
							} else if (tableMeta.rowData[2] === 'LEND' && this.getType().type === 'outgoing fund') {
								return tableMeta.rowData[6] || tableMeta.rowData[13];
							} else if (tableMeta.rowData[4] === 'TOPUPS' || tableMeta.rowData[4] === 'CASHOUT') {
								return 'N/A';
							} else if (
								this.getType().type === 'incoming fund' ||
								this.getType().type === 'outgoing fund'
							) {
								return tableMeta.rowData[5] || tableMeta.rowData[4];
							} else {
								return tableMeta.rowData[5] || tableMeta.rowData[14] || 'N/A';
							}
						}
					}
				},
				{
					name: 'sender_last_name',
					options: {
						display: 'excluded'
					}
				},
				{
					name: 'receiver_first_name',
					label: 'To',
					options: {
						sort: false,
						customBodyRender: (_value, tableMeta) => {
							if (tableMeta.rowData[3] === 'LEND') {
								return tableMeta.rowData[5] || tableMeta.rowData[14] || 'N/A';
							} else if (tableMeta.rowData[2] === 'LEND' && this.getType().type === 'incoming fund') {
								return tableMeta.rowData[4];
							} else if (tableMeta.rowData[2] === 'LEND' && this.getType().type === 'outgoing fund') {
								return tableMeta.rowData[4];
							} else {
								return tableMeta.rowData[7] || tableMeta.rowData[6] || 'N/A';
							}
						}
					}
				},

				{
					name: 'receiver_last_name',
					options: {
						display: 'excluded'
					}
				},
				{
					name: 'state',
					label: 'Status',
					options: {
						sort: false,
						customBodyRender: (value, tableMeta) => {
							return this.setTranStatus(value, tableMeta.rowData[8] || tableMeta.rowData[9]);
						}
					}
				},
				{
					name: 'channel',
					label: 'Channel'
				},

				{
					name: 'principal',
					label: 'Amount(₱) + (LendAmi fee)',
					options: amountColOpts
				},

				{
					name: 'loan_id',
					label: 'Amortization Table',
					options: {
						sort: false,
						customBodyRender: (value, tableMeta) => {
							const queryParams = qs.stringify(qs.parse(window.location.search));

							// Construct the href attribute with the current query parameters
							const transactionUrl = `/amortization-table/${value}?notification=false&${queryParams}&table=${
								tableMeta.rowData[8] === 'PAID' || tableMeta.rowData[9] === 'PAID'
									? 'installments-search'
									: ''
							}&installment_id=${
								this.getType().type === 'ALL' && tableMeta.rowData[9] !== 'PAID'
									? ''
									: this.getType().type === 'ALL' && tableMeta.rowData[9] === 'PAID'
									? tableMeta.rowData[17] || ''
									: tableMeta.rowData[16] || ''
							}`;
							return value ? (
								<a href={transactionUrl} style={{ color: 'red', fontWeight: 'bold' }}>
									Transaction
								</a>
							) : (
								'N/A'
							);
						}
					}
				},
				{
					name: 'loan_id',
					label: 'Action',
					options: {
						sort: false,
						customBodyRender: (value, tableMeta) => {
							const queryParams = qs.stringify(qs.parse(window.location.search));
							let creator_name;
							let acceptor_name;

							if (tableMeta.rowData[2] === 'LEND' || tableMeta.rowData[3] === 'LEND') {
								if (this.getType().type === 'ALL') {
									creator_name = tableMeta.rowData[7];
									acceptor_name = tableMeta.rowData[5] || tableMeta.rowData[14];
								} else {
									creator_name = tableMeta.rowData[6];
									acceptor_name = tableMeta.rowData[4];
								}
							} else {
								if (this.getType().type === 'ALL') {
									creator_name = tableMeta.rowData[5] || tableMeta.rowData[14];
									acceptor_name = tableMeta.rowData[7];
								} else {
									creator_name = tableMeta.rowData[4];
									acceptor_name = tableMeta.rowData[6];
								}
							}

							// Construct the href attribute with the current query parameters
							const reviewUrl = `/admin/customer/review/loan/${value}?${queryParams}&creator_name=${creator_name}&acceptor_name=${acceptor_name}&mode_payment=${
								this.getType().type === 'ALL' && tableMeta.rowData[9] !== 'PAID'
									? tableMeta.rowData[15] || tableMeta.rowData[16] || ''
									: this.getType().type === 'ALL' && tableMeta.rowData[9] === 'PAID'
									? 'ACH'
									: tableMeta.rowData[14] || tableMeta.rowData[15] || ''
							}`;

							return value ? <a href={reviewUrl}>Review</a> : 'N/A';
						}
					}
				},
				{
					name: 'invited_name',
					label: 'invite name',
					options: {
						display: 'excluded'
					}
				},
				{
					name: 'disbursal_mode',
					options: {
						display: 'excluded'
					}
				},
				{
					name: 'latest_disbursal_mode',
					options: {
						display: 'excluded'
					}
				},
				{
					name: 'installment_id',
					options: {
						display: 'excluded'
					}
				}
			]
		};
		const { match } = this.props;

		const queryParams = new URLSearchParams(window.location.search);

		// Convert URLSearchParams to object
		const queryParamsObject = {};
		for (const [key, value] of queryParams.entries()) {
			queryParamsObject[key] = value;
		}

		// Update status based on type
		if (queryParamsObject.status === 'ALL') {
			if (queryParamsObject.type === 'top-up' || queryParamsObject.type === 'cash-out') {
				queryParamsObject.status = 'PENDING,FAILED,SUCCESS';
			} else if (queryParamsObject.type === 'ALL') {
				queryParamsObject.status =
					'PENDING,DECLINE,APPROVE,PRE_MODIFIED,COMPLETED,PAUSED,FAILED,PAYMENTS_STOPED,PAID,SUCCESS,DELETED';
			} else if (queryParamsObject.type === 'outgoing fund') {
				queryParamsObject.status = 'PAID';
			} else {
				queryParamsObject.status =
					'PENDING,DECLINE,APPROVE,PRE_MODIFIED,COMPLETED,PAUSED,PAYMENTS_STOPED,DELETED';
			}
		}

		// Build custom filter query
		let customFilterQuery = '';
		for (const key of Object.keys(queryParamsObject)) {
			if (queryParamsObject[key]) {
				customFilterQuery += `${key}=${queryParamsObject[key]}&`;
			}
		}

		return (
			<>
				<Filter onResetFilter={this.onResetFilter} onSearch={this.onSearch} setType={this.setType} />
				<Table
					columns={
						this.props._hasView || this.props.match.path === '/admin/transactions'
							? tableHeaders._viewCol
							: tableHeaders._defaultCol
					}
					customFilterQuery={(this.state._customFilterQuery || customFilterQuery).replace(/>>/g, '')}
					// customFilterQuery="page=0&"
					dataSourceHandler={this.dataSource}
					dataSourceName="transactions"
					title={this.state._filterTab}
				/>
			</>
		);
	}
}

export default withRouter(hot(module)(Transactions));
